import { env, apimKey } from "../../../config";
import log from "../../../utils/log";

export default async function fetchStoresAsync(cityId, serviceType, serviceId) {
  log("fetchStoresAsync", "request", ...arguments);

  const baseUrl = `https://apim-ikeasa.azure-api.net/GetStores/${env}/`;
  const response = await fetch(
    baseUrl + `${cityId}/${serviceType}/${serviceId}`,
    {
      headers: {
        "Ocp-Apim-Subscription-Key": apimKey,
      },
    }
  );

  if (response.status === 200) {
    const json = await response.json();
    log("fetchStoresAsync", "response", json);

    return json.Stores[0];
  }

  throw new Error(response.status);
}

/*
{
  "Stores": [
    [{
      "DisplayAddress": "Eastern Ring Rd, Riyadh 12863",
      "DisplayAddressLocalized": "الطريق الدائري الشرقي، الرياض 12863",
      "DisplayOrder": "1",
      "Id": "60295",
      "LocalizedName": "معرض ايكيا - الرياض",
      "Name": "IKEA Planning Store - Riyadh",
      "PostalCode": "25006",
      "ServiceURL": "http://192.168.85.24:7047/DynamicsNAV/WS/IKEA%20Store%20Riyadh%20(New)/Page/OnlineServiceOrders",
      "StoreNo": "197",
      "Type": "Store",
      "WorkingHour": "",
      "WorkingHourLocalized": ""
    }, {
      "DisplayAddress": "Eastern Ring Rd, Riyadh 12863",
      "DisplayAddressLocalized": "الطريق الدائري الشرقي، الرياض 12863",
      "DisplayOrder": "2",
      "Id": "60296",
      "LocalizedName": "معرض ايكيا - الرياض",
      "Name": "IKEA Planning Studio - Riyadh",
      "PostalCode": "25005",
      "ServiceURL": "http://192.168.85.24:7047/DynamicsNAV/WS/IKEA%20Store%20Riyadh%20(New)/Page/OnlineServiceOrders",
      "StoreNo": "STUDIO",
      "Type": "Store",
      "WorkingHour": "",
      "WorkingHourLocalized": ""
    }]
  ]
}

*/
